import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";

const Home = () => {
  let user = JSON.parse(localStorage.getItem("users"));
  let name = user?.data?.fullName;
  let role = user?.data?.roleId?.name;

  return (
    <section className="row gy-4">
      <div className="col-xxl-12">
        <h4>Welcome {name}!</h4>
        <br />
        <div className="row gy-4">
          {role === "admin" && (
            <div className="col-xxl-3 col-sm-6">
              <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
                <div className="card-body p-0">
                  <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                    <div className="d-flex align-items-center gap-2">
                      <span className="mb-0 w-48-px h-48-px bg-primary-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                        <Icon
                          icon="mingcute:user-follow-fill"
                          className="icon"
                        />
                      </span>
                      <div>
                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                          New Users
                        </span>
                        <h6 className="fw-semibold">15,000</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {role === "admin" && (
            <div className="col-xxl-3 col-sm-6">
              <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2">
                <div className="card-body p-0">
                  <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                    <div className="d-flex align-items-center gap-2">
                      <span className="mb-0 w-48-px h-48-px bg-success-main flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                        <Icon
                          icon="mingcute:user-follow-fill"
                          className="icon"
                        />
                      </span>
                      <div>
                        <span className="mb-2 fw-medium text-secondary-light text-sm">
                          Active Users
                        </span>
                        <h6 className="fw-semibold">8,000</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="col-xxl-3 col-sm-6">
            <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-3">
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                  <div className="d-flex align-items-center gap-2">
                    <span className="mb-0 w-48-px h-48-px bg-yellow text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="iconamoon:discount-fill" className="icon" />
                    </span>
                    <div>
                      <span className="mb-2 fw-medium text-secondary-light text-sm">
                        Total Sales
                      </span>
                      <h6 className="fw-semibold">5,00,000</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xxl-3 col-sm-6">
            <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-4">
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                  <div className="d-flex align-items-center gap-2">
                    <span className="mb-0 w-48-px h-48-px bg-purple text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="mdi:message-text" className="icon" />
                    </span>
                    <div>
                      <span className="mb-2 fw-medium text-secondary-light text-sm">
                        Conversion
                      </span>
                      <h6 className="fw-semibold">25%</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xxl-3 col-sm-6">
            <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-5">
              <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                  <div className="d-flex align-items-center gap-2">
                    <span className="mb-0 w-48-px h-48-px bg-pink text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                      <Icon icon="mdi:leads" className="icon" />
                    </span>
                    <div>
                      <span className="mb-2 fw-medium text-secondary-light text-sm">
                        Leads
                      </span>
                      <h6 className="fw-semibold">250</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
